/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationForAwsKubernetesUserManagedOnboarded extends models.StorageConfigurationForAwsKubernetesUserManaged {
    constructor() {
        super();
        this.setDiscriminator("StorageConfigurationForAwsKubernetesUserManagedOnboarded");
    }

    getFixupPrototypeFunction() { return StorageConfigurationForAwsKubernetesUserManagedOnboarded.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationForAwsKubernetesUserManagedOnboarded>): StorageConfigurationForAwsKubernetesUserManagedOnboarded {
        let obj = Object.assign(new StorageConfigurationForAwsKubernetesUserManagedOnboarded(), model);
        StorageConfigurationForAwsKubernetesUserManagedOnboarded.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationForAwsKubernetesUserManagedOnboarded>): StorageConfigurationForAwsKubernetesUserManagedOnboarded {
        if (!model) return null;
        return StorageConfigurationForAwsKubernetesUserManagedOnboarded.newInstance(<StorageConfigurationForAwsKubernetesUserManagedOnboarded> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationForAwsKubernetesUserManagedOnboarded) {
        if (!obj) return;

        models.StorageConfigurationForAwsKubernetesUserManagedOnboarded.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationForAwsKubernetesUserManagedOnboarded): boolean {
        if (models.StorageConfigurationForAwsKubernetesUserManaged.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationForAwsKubernetesUserManagedOnboarded.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Reference to the Service Account under which the S3 is present.
     */
    account_id: string;

}
